import ChipsRow from './ChipsRow';

export default ChipsRow;
